import { apiGet, apiPost } from './index'

const getStudent = params => apiGet(`/api/area/student/mobile`, params)

const getLive = params => apiGet(`/api/area/meeting/mobile`, params)

const getDcc = params => apiGet(`/api/area/dcc/${params.areaId}`, params)

const feebBack = params => apiPost('/api/area/leave/word', params)

// 预约记录
const liveGet = params => apiPost('/api/area/meeting/reserve', params)

export { getStudent, getLive, getDcc, feebBack, liveGet }



// WEBPACK FOOTER //
// ./src/api/student.js